export function applyThousandsSeperator (num) {
  const numToFormat = Number(num)
  if ([null, undefined, ''].includes(num) || isNaN(numToFormat)) return ''
  return numToFormat.toLocaleString(undefined, { maximumFractionDigits: 10 })
}
